// extracted by mini-css-extract-plugin
module.exports = {"workersn":"index_workersn_1bvTn","customerIframe":"index_customerIframe_1my_k"};